module.exports = __webpack_public_path__ + "static/img/select1.79b7506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product2/select1.png
// module id = 9N5y
// module chunks = 12